import { render, staticRenderFns } from "./stackColumn.vue?vue&type=template&id=2d59b215&scoped=true"
import script from "./stackColumn.vue?vue&type=script&lang=js"
export * from "./stackColumn.vue?vue&type=script&lang=js"
import style0 from "./stackColumn.vue?vue&type=style&index=0&id=2d59b215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d59b215",
  null
  
)

export default component.exports